import PageTypeB from "../components/pageTypeB/PageTypeB";
import { pagesDataB } from "../data/pagesData";

const Page13 = () => {
  return (
    <PageTypeB
      title={pagesDataB[3].title}
      paragraph1={pagesDataB[3].paragraph1}
      paragraph2={pagesDataB[3].paragraph2}
      paragraph3={pagesDataB[3].paragraph3}
    />
  );
};

export default Page13;
